$(document).on("click", ".question_product,.custom_icons_faq_main .icons_with_text_item_title", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.custom_icons_faq_main .icons_with_text_item_title').removeClass('active');
    jQuery('.question_product,.custom_icons_faq_main .icons_with_text_item_title').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});






$(document).on("click", ".perfume_item:not(.open)", function (e) {
  e.preventDefault();
$('.perfume_item').removeClass('open');
$(this).addClass('open');
});
$(document).on("click", ".perfume_item.open", function (e) {
  e.preventDefault();
$('.perfume_item').removeClass('open');
});



$(document).on("click", "a[href='#select']", function (e) {
  e.preventDefault();
  document.querySelector('.hk_product_label1').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});





$(document).on("click", ".perfume_list_item", function (e) {
  e.preventDefault();
  var target = $(this).parents('.perfume_item');
  var image_src = $(this).find('img').attr('src');
  var title = $(this).find('.perfume_list_item_title').html();
  var variant_id = $(this).attr('variant_id');
  var product_title = $(this).attr('product_title');
  target.find('img').attr('src', image_src);
  target.find('.perfume_item_title').html(title);
  target.attr('variant_id', variant_id);
  target.attr('product_title', product_title);
  target.addClass('active');
});











$(document).on("click", '.custom_ajax_atc', function(e) {
  e.preventDefault();
  var $btn = $(this).addClass('loading_hk'),
      id = $btn.attr('variant_id'),
      quantity = $btn.attr('quantity'),
      selling_plan = $btn.attr('selling_plan'),
      data = { id: id, quantity: quantity };

  if (selling_plan) data.selling_plan = selling_plan;

  $.post('/cart/add.js', data, function () { 
$btn.removeClass('loading_hk');
    // Update cart bubble only
    $.getJSON("/cart.js", function(cart) {
      var count = cart.item_count;
      $("span.header-controls__cart-count").text(count);
    });
   //location.href = '/checkout';
  }, 'json');
});

